import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { SubmitComponent, TextComponent, RadioComponent } from '@app/shared/forms';
import { StudentFacade } from '@app/admin/store/student';
import { TranslateModule } from '@ngx-translate/core';
import { faker } from '@faker-js/faker';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { StudentRole } from '@app/admin/store/types';

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, TranslateModule, TextComponent, SubmitComponent, RadioComponent],
    host: { id: 'students' },
})
export class AddComponent implements OnInit, OnDestroy {
    private readonly studentFacade = inject(StudentFacade);
    private readonly userFacade = inject(UserFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly destroyRef = inject(DestroyRef);
    private readonly router = inject(Router);
    readonly activatedRoute = inject(ActivatedRoute);

    readonly saved$ = this.studentFacade.saved$;
    readonly saving$ = this.studentFacade.saving$;

    readonly form = this.formBuilder.group({
        firstName: this.formBuilder.control(faker.person.firstName()),
        lastName: this.formBuilder.control(faker.person.lastName()),
        email: this.formBuilder.control(faker.internet.email().toLocaleLowerCase()),
        password: this.formBuilder.control(faker.internet.password()),
        location: this.formBuilder.control(`${faker.location.city()}, ${faker.location.country()}`),
        role: this.formBuilder.control<StudentRole>('teacher'),
        description: this.formBuilder.control(faker.lorem.paragraph()),
    });

    ngOnInit() {
        this.studentFacade.saved$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                filter((saved) => saved === true),
                tap(() => this.router.navigate([{ outlets: { modal: null } }])),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.studentFacade.clear();
    }

    onSubmit() {
        const value = this.form.getRawValue();
        const user = this.userFacade.user();

        if (user) {
            this.studentFacade.addStudent({ ...value, schoolId: user.schoolId });
        }
    }
}
